<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
            <el-col class="flex-box al-c" :span="4">
                <el-button type="primary" @click="initPage">查询</el-button>
            </el-col>
        </Sift>

        <div class="table-con">
            <el-table class="w100 mt20 table"   header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list">
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="姓名"></el-table-column>
                <el-table-column align="center" prop="phone" label="电话"></el-table-column>
                <el-table-column align="center" prop="identityCard" label="身份证"></el-table-column>
                <el-table-column align="center" prop="reason" label="事由">
                    <template slot-scope="scope">
                        <span>{{scope.row.reason == '1' ? '入校培训' : scope.row.reason == '2' ? '工程实施' : '会议' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="updateTime" label="照片"></el-table-column>
                <el-table-column align="center" prop="status" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '1' || scope.row.status == '2'">
                            {{scope.row.status == '1' ? '已通过'  : '已驳回'}}
                        </div>
                        <div v-else class="to-use">
                            <span class="info" @click="setStatus(scope.row.id, '1')">通过</span>
                            <span class="danger" @click="setStatus(scope.row.id, '2')">驳回</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>

        <!-- 详情、新增 -->
        <ThemeDialog ref="themeDialog" @saveSuccess="saveSuccess"/>

    </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import ThemeDialog from "@/components/management/theme/ThemeDialog";
    import { getSubjectList,getSubjectInfo, handleSubjectDelete} from '@/api/managementCenter/themeManage';
    import { getRegisterUserPage, setRegisterStatus} from '@/api/admin/user';

    export default {
        name: "thirdPartyManagement",
        components: {
            Sift,
            ThemeDialog
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData : [
                    {
                        type: "text",
                        key: "keyWord",
                        label: "关键字查询",
                        placeholder: "请输入关键字",
                        default: ""
                    },
                    {
                        type: "select",
                        key: "status",
                        label: "审核状态",
                        placeholder: "请选择审核状态",
                        default: "",
                        data: [
                            {
                                label: '通过',
                                value: '1'
                            },
                            {
                                label: '驳回',
                                value: '2'
                            }
                        ]
                    },
                ],
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                },
                total: 0
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
        },
        methods: {
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getRegisterUserPage(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            // 删除
            deleteFn (id, name) {
                this.$confirm( "是否确定删除" + name + " ?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            //审核
            setStatus(id,status) {
                let params = {
                    id:id,
                    status: status
                }
                setRegisterStatus(params).then(({data}) =>{
                    if(data.code == '0'){
                        this.getListFn();
                        this.$message.success("操作成功!" );
                    }else{
                        this.$message.warning( data.msg||"操作失败！" );
                    }
                })
            },
            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    ...this.$refs.needSift.getValue(),
                    current:1
                }
                this.getListFn();
            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            saveSuccess(){
                this.getListFn();
            }
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>
